import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { BUTTON_VARIANTS } from "~/common/constants";
import { deleteSpaces } from "../utils/deleteSpaces";
import { Button, SectionHeader } from "./ui";

interface ImagePromptCardProps extends PropsWithChildren {
  title?: string;
  handleContinue: () => void;
  handleGoBack?: () => void;
  goBackLabel?: string;
  continueLabel?: string;
  pendingContinue?: boolean;
  isNavigatingBack?: boolean;
  className?: string;
  imageContainerClassName?: string;
  subtitle?: string;
  content?: React.ReactNode;
}

export const ImagePromptCard = ({
  title,
  subtitle,
  handleContinue,
  handleGoBack,
  pendingContinue = false,
  isNavigatingBack = false,
  goBackLabel,
  continueLabel,
  imageContainerClassName,
  className,
  children,
  content,
}: ImagePromptCardProps) => (
  <>
    <div
      className={twMerge(
        "z-50 -mb-12 flex size-32 items-center justify-center rounded-full p-2 md:-mb-16 lg:-mb-20 xl:-mb-24",
        imageContainerClassName,
      )}
    >
      {children}
    </div>
    <div
      className={twMerge(
        "flex w-full max-w-96 flex-col items-center gap-6 rounded-3xl bg-white p-6 pt-16",
        className,
      )}
    >
      {title && (
        <SectionHeader className="w-full text-center text-3xl">
          {title}
        </SectionHeader>
      )}
      {subtitle && (
        <p className="text-center text-base font-light leading-5 text-gray-70">
          {subtitle}
        </p>
      )}
      {content && content}
      <div className="flex w-full flex-col gap-2">
        <Button
          isLoading={pendingContinue}
          onClick={handleContinue}
          disabled={pendingContinue || isNavigatingBack}
          id={continueLabel ? deleteSpaces(continueLabel) : "continueButton"}
        >
          {continueLabel ?? "Continue"}
        </Button>
        {handleGoBack && (
          <Button
            onClick={handleGoBack}
            disabled={isNavigatingBack || pendingContinue}
            variant={BUTTON_VARIANTS.outline_none_underline}
            id={goBackLabel ? deleteSpaces(goBackLabel) : "goBackButton"}
            className="disabled:cursor-not-allowed disabled:justify-center disabled:bg-transparent"
          >
            {goBackLabel ?? "Go Back"}
          </Button>
        )}
      </div>
    </div>
  </>
);
